


























import { defineComponent, PropType, ref } from 'vue';
import Icon from './Icon.vue';
import { iconClassEnum } from '../enums/iconClassEnum';

export interface SortDropdownOption<T extends string = string> {
  value: T;
  label: string;
}

export default defineComponent({
  name: 'SortDropdown',
  components: { Icon },
  props: {
    value: {
      type: String as PropType<string>,
      required: true,
    },
    options: {
      type: Array as PropType<SortDropdownOption[]>,
      required: true,
    },
  },
  emits: ['input'],
  setup(props, { emit }) {
    const isOpen = ref(false);

    const selectOption = (value: string) => {
      if (props.value === value) {
        return;
      }
      emit('input', value);
    };

    return {
      isOpen,
      selectOption,
      iconClassEnum,
    };
  },
});
